import { Input, InputProps, InputRef } from 'antd';
import { debounce } from 'lodash';
import { useEffect, useMemo, useRef, useState } from 'react';
type InputSearchV2Props = Omit<InputProps, 'onChange'> & {
  loading?: boolean;
  onChange?: (value: string) => void;
  debounceTime?: number;
  value?: string;
  isDebounce?: boolean;
};
const InputSearch = ({
  loading,
  onChange,
  debounceTime,
  value,
  placeholder,
  onFocus,
  onBlur,
  isDebounce,
  size = 'middle',
  onPressEnter,
  ...props
}: InputSearchV2Props) => {
  const [tempValue, setTempValue] = useState('');
  const [isFocus, setIsFocus] = useState(false);

  const refInput = useRef<InputRef>(null);

  useEffect(() => {
    if (refInput.current && refInput.current.input && !isFocus) {
      setTempValue(value?.toString() || '');
      refInput.current.input.value = value || '';
    }
  }, [value]);

  const debounceHandleChange = useMemo(
    () =>
      debounce((nextValue: string) => {
        if (!loading) {
          if (onChange) onChange(nextValue.trim());
        }
      }, debounceTime || 200),
    [loading, onChange, debounceTime]
  );

  useEffect(() => {
    return () => {
      debounceHandleChange.cancel();
    };
  }, [debounceHandleChange]);

  const handleChangeVal = (value: string) => {
    if (!loading) {
      if (onChange) onChange(value);
    }
  };

  return (
    <Input.Search
      prefixCls='input-search'
      value={tempValue}
      size={size}
      placeholder={placeholder}
      ref={refInput}
      onFocus={(e) => {
        setIsFocus(true);
        if (onFocus) onFocus(e);
        e.target.select();
      }}
      onBlur={(e) => {
        debounceHandleChange.cancel();
        setIsFocus(false);
        if (onBlur) onBlur(e);
      }}
      onChange={(e) => {
        setTempValue(e.target.value);
        if (isDebounce === false) {
          debounceHandleChange.cancel();
          handleChangeVal(e.target.value);
        } else {
          debounceHandleChange(e.target.value);
        }
      }}
      onPressEnter={(e) => {
        debounceHandleChange.cancel();
        if (onPressEnter) onPressEnter(e);
      }}
      {...props}
    />
  );
};
export default InputSearch;
